import { render, staticRenderFns } from "./LandingCarbonPage.vue?vue&type=template&id=fdb47184&scoped=true"
import script from "./LandingCarbonPage.vue?vue&type=script&lang=ts"
export * from "./LandingCarbonPage.vue?vue&type=script&lang=ts"
import style0 from "./LandingCarbonPage.vue?vue&type=style&index=0&id=fdb47184&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdb47184",
  null
  
)

export default component.exports